import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';
import { Col, Image, Row } from 'antd';
import { Button } from '../Button/Button';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

export type ProofDeliveryModalProps = {
  visible: boolean;
  imgUrl: string;
  onClose: () => void;
};

const onDownload = (url: string) =>
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const url = URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.download = 'image.png';
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.remove();
    });

const ProofDeliveryModal = ({ visible, imgUrl, onClose }: ProofDeliveryModalProps) => {
  const { t } = useTranslation();
  const onDownloadClick = useCallback(async () => {
    await onDownload(imgUrl);
    onClose();
  }, [imgUrl]);
  const { xs: isXsBreakpoint } = useBreakpoint();
  return (
    <Modal
      width={1000}
      titleText={t('modal.proofDelivery.title')}
      onClose={onClose}
      visible={visible}
      footer={
        <Row gutter={16} style={{ justifyContent: 'end', width: '100%' }}>
          <Col style={{ textAlign: 'end' }} xs={0} sm={5} md={5}>
            <Button onClick={onClose} data-testid="proofDeliveryBackButton">
              {t('modal.proofDelivery.back')}
            </Button>
          </Col>
          <Col style={{ textAlign: 'end' }} xs={24} sm={5} md={3}>
            <Button block={isXsBreakpoint} type="primary" onClick={onDownloadClick} data-testid="downloadProofButton">
              {t('modal.proofDelivery.download')}
            </Button>
          </Col>
        </Row>
      }
    >
      <Image preview={false} loading={'eager'} src={imgUrl} />
    </Modal>
  );
};

export default ProofDeliveryModal;
